export default {
  getDivision: (state) => state.division,
};
